import { create } from 'zustand';

export interface RobotsQuestion {
  question: string;
  answer: string;
}

interface RobotsQuestionsStore {
  questions: RobotsQuestion[];
}

export const robotsQuestionsStore = create<RobotsQuestionsStore>(() => ({
  questions: [],
}));
